import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import {
  REQUEST,
  fetchSuccess,
  fetchFailure,
  marketplaceConflict,
  clearMarketplaceConflict,
} from '../../actions/signals/deleteBulk';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';

function* operation(action) {
  const { keys, streams, force } = action.payload || {};
  yield put(clearMarketplaceConflict());
  try {
    const response = yield call(
      axios.post,
      `${config.API_URL}/signal/delete`,
      { keys: keys || [], event_streams: streams || [], force: !!force },
      { headers: getLocalUser() },
    );
    const body = response?.data?.data?.data ?? {};
    yield put(fetchSuccess({ ...body, keys, streams, at: Date.now() }));
    const deleted = (body.deleted || keys || []).length;
    const deletedStreams = (body.deleted_event_streams || []).length;
    const skipped = (body.skipped_marketplace || []).length;
    const parts = [];
    if (deleted) parts.push(`${deleted} signal${deleted === 1 ? '' : 's'}`);
    if (deletedStreams) {
      parts.push(`${deletedStreams} event stream${deletedStreams === 1 ? '' : 's'}`);
    }
    yield put({
      type: 'SHOW_SUCCESS_SNACKBAR',
      message: `Deleted ${parts.join(' and ') || 'nothing'}`
        + (skipped ? ` (${skipped} subscribed skipped)` : ''),
    });
  } catch (error) {
    const status = error?.response?.status;
    const raw = error?.response?.data || {};
    const body = raw?.data && typeof raw.data === 'object' ? raw.data : raw;
    // Canonical envelope: {error: {code, message, details}}; tolerate the
    // older flat-string form as well.
    const errCode = typeof body?.error === 'object' ? body.error?.code : body?.error;
    const errMessage =
      (typeof body?.error === 'object' && body.error?.message) || body?.message;
    const isMarketplaceConflict =
      status === 409 && (
        errCode === 'active_marketplace_subscribers'
        || errCode === 'published_marketplace_listing'
      );
    if (isMarketplaceConflict) {
      yield put(marketplaceConflict({
        keys,
        streams,
        kind:               errCode,
        message:            errMessage,
        active_subscribers: body.active_subscribers,
        listings:           body.listings || [],
      }));
      yield put(fetchFailure({ keys, conflict: true }));
      return;
    }
    yield put(Error(error));
    yield put(fetchFailure({ keys, streams }));
    yield put({
      type: 'SHOW_ERROR_SNACKBAR',
      message: 'Could not delete the selected signals',
    });
  }
}

export function* watch() {
  yield takeEvery(REQUEST, operation);
}
